import {Vue} from '~/addiesaas'
import ReSocialMediaStorage from './media/storage'
Vue.component(ReSocialMediaStorage.name, ReSocialMediaStorage)

export default {
  ReSocialMediaStorage
}
